import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { device, size } from "constants/Devices";
import { ICompany } from "types/interfaces/customers/ICustomer";
import { sanityImgBuilder as builder } from "../sanity";
import { ROUTES } from "routes/constants";
import { Typography, Icon } from "@beamcloud/design-system";
import Logo from "./CompanyLogo";
import { typography } from "../../components/typography";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

interface IProps {
  title: string;
  company: ICompany;
  coverImage: any;
  slug: string;
}

const CaseStudyCard = ({ title, coverImage, company, slug }: IProps) => {
  const imageUrl = coverImage.mockImageUrl ? coverImage.mockImageUrl : builder.image(coverImage).url();

  return (
    <Card>
      <Link to={`${ROUTES.customers}/${slug}`}>
        <CardImage alt="card-cover-image" src={imageUrl} />
      </Link>
      <Title>
        <Link to={`${ROUTES.customers}/${slug}`}>{title}</Link>
      </Title>
      <Typography tag="h1" variant="textLgPlus" color="gray100">
        <StyledLink to={`${ROUTES.customers}/${slug}`}>
          <Icon icon={faArrowRight} size="base" color="gray11" /> Read case study
        </StyledLink>
      </Typography>
      {/* <CompanyLogo company={company} size="small" /> */}
    </Card>
  );
};

export default CaseStudyCard;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 20px;
  flex: 0 1 calc(50% - 16px);
  min-width: 280px;
  max-width: 544px;
  background: ${props => props.theme.colors.gray3};
  border-radius: 8px;

  @media ${device.mobileXL} {
    flex: 0 1 100%;
    max-width: 100%;
    min-width: 100%;
  }
`;

const Title = styled.h1`
  ${typography.title24};
  color: ${props => props.theme.colors.gray100};
  margin: 0;
  width: 100%;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

const CardImage = styled.img`
  border-radius: 8px;
  width: 100%;
  aspect-ratio: 48/27;
  object-fit: cover;
  display: block;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const CompanyLogo = styled(Logo)`
  padding: 12px 0px 0px;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  margin-top: -4px;
  color: ${props => props.theme.colors.gray12};

  svg {
    margin-top: 1px;
  }
`;
